module.exports = __webpack_public_path__ + "static/media/mostafa afifi.6d699d08.webp";